import { useEffect, useState } from "react";
import {
  dieStatusAPI,
  supplierDieAPI,
  locationAPI,
  customerAPI,
  dieMasterAPI,
  DieTypeAPI,
  ToolingAPI,
  DiePurchaseOrderAPI,
} from "../../utlis/apiService";
import Loader from "../../common/Loader";
import { notify } from "../../common/Toast";
import Model from "../../common/Model";
import EntityAddModal from "../../common/EntityAddModal/index";
import InputField from "../../common/InputField";
import {
  MdAttachFile,
} from "react-icons/md";
import { FormHeader, FormFooter } from "../../common/Shared";

const DieForm = ({
  initialData,
  onSubmit,
  onCancel,
  isEditing,
  isSaving = false,
}) => {
  const today = new Date().toISOString()?.split("T")[0];
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const [formData, setFormData] = useState({
    id: 0,
    dieNumber: "",
    dieDate: today,
    subDieNo: "",
    invoiceNo: "",
    profileName: "",
    orderWeight: "",
    currentWeight: "",
    seriesName: "",
    customer_Id: "",
    width: "",
    height: "",
    supplier_Id: "",
    status_Id: 1,
    location_Id: "",
    range: "",
    range_Per: "",
    die_Pdf: null,
    die_Image: null,
    created_By: userId,
    toolingSize_Id: "",
    die_Type_Id: "",
    no_Of_Cavity: "",
    hardness: "",
    area_Sqmm: "",
    perimeter: "",
    profileThickness: "",
  });
  const [errors, setErrors] = useState({});
  const [pdfFile, setPdfFile] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [dieTypeOptions, setDieTypeOptions] = useState([]);
  const [toolingSizeOptions, setToolingSizeOptions] = useState([]);
  const [attachedPdfName, setAttachedPdfName] = useState(null);
  const [modalType, setModalType] = useState(null);

  const loadDropdowns = async () => {
    try {
      const [customers, suppliers, statuses, locations, dieType, toolingSize] =
        await Promise.all([
          customerAPI.getAll(),
          supplierDieAPI.getAll(),
          dieStatusAPI.getAll(),
          locationAPI.getAll(),
          DieTypeAPI.getAll(),
          ToolingAPI.getAll(),
        ]);

      setCustomerOptions(
        customers.data.map((c) => ({
          value: c.customer_Id,
          label: c.name,
        })),
      );
      setSupplierOptions(
        suppliers.data.map((s) => ({
          value: s.supplier_Id,
          label: s.supplier_Name,
        })),
      );
      setStatusOptions(
        statuses.map((s) => ({ value: s.id, label: s.status_Name })),
      );
      if (!initialData && !formData.status_Id) {
        setFormData((prev) => ({ ...prev, status_Id: 1 }));
      }
      setLocationOptions(
        locations.data.map((l) => ({ value: l.location_Id, label: l.name })),
      );
      setDieTypeOptions(
        dieType.map((d) => ({ value: d.die_Type_Id, label: d.name })),
      );
      setToolingSizeOptions(
        toolingSize.map((t) => ({
          value: t.tooling_Size_Id,
          label: t.name,
        })),
      );
    } catch (err) {
      notify("Dropdown loading failed", "error");
    }
  };

  useEffect(() => {
    loadDropdowns();
  }, []);

  const handlePdfChange = (file) => {
    setPdfFile(file);
    setAttachedPdfName(file?.name || null);
  };

  useEffect(() => {
    if (initialData) {
      let w = "";
      let h = "";
      const whVal = initialData.widthHeight || initialData.width_Height || "";
      if (whVal) {
        const parts = whVal.split(/[xX*]/);
        w = parts[0]?.trim() || "";
        h = parts.length > 1 ? parts.slice(1).join("X")?.trim() : "";
      }

      setFormData({
        ...formData,
        ...initialData,
        width: w,
        height: h,
        range: initialData.to_Kg !== undefined ? initialData.to_Kg : (initialData.To_Kg !== undefined ? initialData.To_Kg : (initialData.range || initialData.die_Range || "")),
        range_Per: 0,
        die_Image: initialData.die_Image || null,
        die_Pdf: initialData.die_Pdf || null,
        dieDate: initialData.dieDate?.split("T")[0] || "",
        status_Id: initialData.status_Id || 1,
      });
      setImageFile(initialData.die_Image || null);
      setAttachedPdfName(initialData.die_Pdf?.split("/").pop() || null);
    } else {
      setFormData({
        id: 0,
        dieNumber: "",
        dieDate: today,
        subDieNo: "",
        invoiceNo: "",
        profileName: "",
        orderWeight: "",
        currentWeight: "",
        seriesName: "",
        customer_Id: "",
        width: "",
        height: "",
        supplier_Id: "",
        status_Id: "",
        location_Id: "",
        range: "",
        range_Per: "",
        die_Pdf: null,
        die_Image: null,
        created_By: userId,
        tooling_Size: "",
        die_Type_Id: "",
        no_Of_Cavity: "",
        hardness: "",
        area_Sqmm: "",
        perimeter: "",
        profileThickness: "",
      });
      setAttachedPdfName(null);
    }
  }, [initialData]);

  const fetchSubDieNo = async (dieNo) => {
    if (!dieNo) return;
    try {
      const res = await DiePurchaseOrderAPI.getNewSubDieNo(dieNo);
      if (res?.subDieNo) {
        setFormData((prev) => ({ ...prev, subDieNo: res.subDieNo }));
      }
    } catch (err) {
      console.error("Failed to fetch sub die no", err);
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = (type) => {
    const formDataToSend = new FormData();

    formDataToSend.append("Id", formData.id);
    formDataToSend.append("DieNumber", formData.dieNumber);
    formDataToSend.append("DieDate", formData.dieDate);
    formDataToSend.append("SubDieNo", formData.subDieNo || "");
    formDataToSend.append("Invoice_No", formData.invoiceNo || "");
    formDataToSend.append("Profile_Name", formData.profileName || "");
    formDataToSend.append("Series_Name", formData.seriesName || "");
    formDataToSend.append("Customer_Id", formData.customer_Id || "");
    const whString = (formData.width || formData.height) ? `${formData.width || ""}X${formData.height || ""}` : "";
    formDataToSend.append("Width_Height", whString);
    formDataToSend.append("CurrentWeight", formData.currentWeight);
    formDataToSend.append("OrderWeight", formData.orderWeight);
    formDataToSend.append("Status_Id", formData.status_Id);
    formDataToSend.append("Supplier_Id", formData.supplier_Id);
    formDataToSend.append("Location_Id", formData.location_Id);
    formDataToSend.append("From_Kg", formData.orderWeight || 0);
    formDataToSend.append("To_Kg", formData.range || 0);
    formDataToSend.append("Range_Per", 0);
    formDataToSend.append("Tooling_Size", formData.toolingSize_Id || "");
    formDataToSend.append("Die_Type_Id", formData.die_Type_Id || "");
    formDataToSend.append("No_Of_Cavity", formData.no_Of_Cavity || "");
    formDataToSend.append("Hardness", formData.hardness || "");
    formDataToSend.append("Area_Sqmm", formData.area_Sqmm || "");
    formDataToSend.append("Perimeter", formData.perimeter || "");
    formDataToSend.append("Profile_Thickness", formData.profileThickness || 0);
    if (imageFile instanceof File) {
      formDataToSend.append("Die_Image", imageFile);
    } else if (formData.id === 0) {
      formDataToSend.append("Die_Image", null);
    }

    if (pdfFile instanceof File) {
      formDataToSend.append("Die_Pdf", pdfFile);
    }

    if (formData.id === 0) {
      formDataToSend.append("Created_By", formData.created_By);
    } else {
      formDataToSend.append("Modify_By", 1);
    }
    onSubmit(formDataToSend, type);
  };

  const optionMap = {
    customer: {
      setter: setCustomerOptions,
      field: "customer_Id",
    },
    supplier: {
      setter: setSupplierOptions,
      field: "supplier_Id",
    },
    status: {
      setter: setStatusOptions,
      field: "status_Id",
    },
    location: {
      setter: setLocationOptions,
      field: "location_Id",
    },
    dieType: {
      setter: setDieTypeOptions,
      field: "die_Type_Id",
    },
    toolingSize: {
      setter: setToolingSizeOptions,
      field: "tooling_Size_Id",
    },
  };

  const handleEntityAddSuccess = async (type) => {
    const { setter } = optionMap[type];

    try {
      let updatedData;

      switch (type) {
        case "customer":
          updatedData = await customerAPI.getAll();
          setter(
            updatedData.data.map((c) => ({
              value: c.customer_Id,
              label: c.name,
            })),
          );
          break;
        case "supplier":
          updatedData = await supplierDieAPI.getAll();
          setter(
            updatedData.data.map((s) => ({
              value: s.supplier_Id,
              label: s.supplier_Name,
            })),
          );
          break;
        case "status":
          updatedData = await dieStatusAPI.getAll();
          setter(
            updatedData.map((s) => ({
              value: s.id,
              label: s.status_Name,
            })),
          );
          break;
        case "location":
          updatedData = await locationAPI.getAll();
          setter(
            updatedData.data.map((l) => ({
              value: l.location_Id,
              label: l.name,
            })),
          );
          break;
        case "dieType":
          updatedData = await DieTypeAPI.getAll();
          setter(
            updatedData.map((l) => ({
              value: l.die_Type_Id,
              label: l.name,
            })),
          );
          break;
        case "toolingSize":
          updatedData = await ToolingAPI.getAll();
          setter(
            updatedData.map((l) => ({
              value: l.tooling_Size_Id,
              label: l.name,
            })),
          );
          break;
        default:
          return;
      }

      setModalType(null);
    } catch (err) {
      notify("Failed to refresh dropdown", "error");
    }
  };


  const onFileRemove = async (fileType, dieId) => {
    try {
      const apiCall =
        fileType === "image"
          ? dieMasterAPI.dieIMGDelete(dieId)
          : dieMasterAPI.diePDFDelete(dieId);

      const res = await apiCall;

      if (res.success) {
        notify(`${fileType.toUpperCase()} deleted successfully`, "success");
        if (fileType === "image") setImageFile(null);
        else setPdfFile(null);
      } else {
        notify(`Failed to delete ${fileType}`, "error");
      }
    } catch (error) {
      console.error(`Delete ${fileType} error:`, error);
      notify(`Something went wrong while deleting ${fileType}`, "error");
    }
  };

  const parseWeightVal = (val) => {
    if (val === null || val === undefined || val === "") return 0;
    if (typeof val === "number") return val;
    const cleaned = String(val).replace(/[^0-9.-]+/g, "");
    return Number(cleaned) || 0;
  };
  const currentWtNum = parseWeightVal(formData.currentWeight);
  const rangeNum = parseWeightVal(formData.range);
  const isOutOfRange = rangeNum > 0 && currentWtNum > rangeNum;

  return (
    <div className="flex flex-col h-full bg-white overflow-hidden font-plus relative">
      {isSaving && <Loader centered />}
      <FormHeader
        title={isEditing ? "Update Die" : "New Die"}
        onCancel={onCancel}
      />

      <form
        className="flex-1 overflow-y-auto p-5 bg-white"
        onSubmit={(e) => {
          e.preventDefault();
          handleSave("close");
        }}
      >
        <div className="mb-6">
          <div className="flex items-center gap-4 mb-4 border-b border-gray-100 pb-2">
            <span className="w-1.5 h-4 bg-primary"></span>
            <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-[2.5px]">
              General Details
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <InputField
              type="date"
              label="Entry Date"
              value={formData.dieDate}
              onChange={(v) => handleChange("dieDate", v)}
              className="rounded-none border-gray-200 focus:border-primary"
            />
            <InputField
              label="Die No."
              required
              value={formData.dieNumber}
              onChange={(v) => handleChange("dieNumber", v)}
              onBlur={() => fetchSubDieNo(formData.dieNumber)}
              placeholder="e.g., D-1002"
              error={errors.dieNumber}
              className="rounded-none border-gray-200 focus:border-primary"
            />
            <InputField
              label="Sub Die No."
              value={formData.subDieNo}
              onChange={(v) => handleChange("subDieNo", v)}
              placeholder="..."
              readOnly
              className="rounded-none bg-gray-50 border-gray-200"
            />
            <InputField
              label="Invoice No."
              value={formData.invoiceNo}
              onChange={(v) => handleChange("invoiceNo", v)}
              placeholder="INV-123"
              className="rounded-none border-gray-200 focus:border-primary"
            />
            <InputField
              type="selectWithAdd"
              label="Customer"
              value={formData.customer_Id}
              onChange={(s) => handleChange("customer_Id", s?.value)}
              options={customerOptions}
              placeholder="Select Customer"
              onAddNewClick={() => setModalType("customer")}
            />
            <InputField
              type="selectWithAdd"
              label="Supplier"
              value={formData.supplier_Id}
              onChange={(s) => handleChange("supplier_Id", s?.value)}
              options={supplierOptions}
              placeholder="Select Supplier"
              onAddNewClick={() => setModalType("supplier")}
            />
            <InputField
              type="selectWithAdd"
              label="Status"
              value={formData.status_Id}
              onChange={(s) => handleChange("status_Id", s?.value)}
              options={statusOptions}
              placeholder="Select Status"
              onAddNewClick={() => setModalType("status")}
            />
            <InputField
              type="selectWithAdd"
              label="Location"
              value={formData.location_Id}
              onChange={(s) => handleChange("location_Id", s?.value)}
              options={locationOptions}
              placeholder="Select Location"
              onAddNewClick={() => setModalType("location")}
            />
          </div>
        </div>

        {/* Engineering Specifications */}
        <div className="mb-6">
          <div className="flex items-center gap-4 mb-4 border-b border-gray-100 pb-2">
            <span className="w-1.5 h-4 bg-primary"></span>
            <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-[2.5px]">
              Technical Specifications
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <InputField
              label="Profile Name"
              value={formData.profileName}
              onChange={(v) => handleChange("profileName", v)}
              className="rounded-none" placeholder="Window Section"
            />
            <InputField
              label="Series Name"
              value={formData.seriesName}
              onChange={(v) => handleChange("seriesName", v)}
              className="rounded-none"
              placeholder="Architectural"
            />
            <InputField
              label="Order Wt."
              required
              placeholder="2.500"
              value={formData.orderWeight}
              onChange={(v) => handleChange("orderWeight", v)}
              className="rounded-none border-gray-200 focus:border-primary"
            />
            <InputField
              label="Current Wt."
              placeholder="2.450"
              value={formData.currentWeight}
              onChange={(v) => handleChange("currentWeight", v)}
              error={isOutOfRange ? `Current Wt. cannot exceed Die Range (${formData.range || 0} Kg)` : errors.currentWeight}
              bgColor={isOutOfRange ? "!bg-red-50 !text-red-900 font-extrabold" : ""}
              className={`rounded-none ${isOutOfRange ? "!border-red-500 !bg-red-50 !text-red-900 font-extrabold" : "border-gray-200 focus:border-primary"}`}
            />

            <InputField
              label="Profile Thickness"
              value={formData.profileThickness}
              onChange={(v) => handleChange("profileThickness", v)}
              className="rounded-none border-gray-200 focus:border-primary"
              placeholder="0.00"
            />

            <InputField
              label="Die Range"
              value={formData.range}
              onChange={(v) => handleChange("range", v)}
              className="rounded-none border-gray-200 focus:border-primary"
              placeholder="3.60"
            />

            <InputField
              label="Width"
              value={formData.width}
              onChange={(v) => handleChange("width", v)}
              className="rounded-none border-gray-200 focus:border-primary"
              placeholder="100"
            />
            <InputField
              label="Height"
              value={formData.height}
              onChange={(v) => handleChange("height", v)}
              className="rounded-none border-gray-200 focus:border-primary"
              placeholder="50"
            />
            <InputField
              type="selectWithAdd"
              label="Die Type"
              value={formData.die_Type_Id}
              options={dieTypeOptions}
              onChange={(s) => handleChange("die_Type_Id", s?.value)}
              placeholder="Select Type"
              onAddNewClick={() => setModalType("dieType")} />
            <InputField
              type="selectWithAdd"
              label="Tooling Size"
              value={formData.toolingSize_Id}
              options={toolingSizeOptions}
              onChange={(s) => handleChange("toolingSize_Id", s?.value)}
              placeholder="Tooling Size Name"
              onAddNewClick={() => setModalType("toolingSize")}
            />
            <InputField
              label="No Of Cavity"
              value={formData.no_Of_Cavity}
              onChange={(v) => handleChange("no_Of_Cavity", v)}
              className="rounded-none" placeholder="50"
            />
            <InputField
              label="Hardness"
              value={formData.hardness}
              onChange={(v) => handleChange("hardness", v)}
              className="rounded-none"
              placeholder="50"
            />
            <InputField
              label="Area Sq.Mm"
              value={formData.area_Sqmm}
              onChange={(v) => handleChange("area_Sqmm", v)}
              className="rounded-none"
              placeholder="460.23"
            />
            <InputField
              label="Perimeter"
              value={formData.perimeter}
              onChange={(v) => handleChange("perimeter", v)}
              className="rounded-none"
              placeholder="454.95"
            />
          </div>
        </div>

        {/* Media & Documentation Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="">
            <div className="flex items-center gap-3 mb-6">
              <MdAttachFile size={18} className="text-primary" />
              <span className="text-[10px] font-black text-gray-400 uppercase tracking-[2.5px]">
                Die Pdf
              </span>
            </div>
            <div className="">
              <InputField
                type="pdf"
                label=""
                onChange={handlePdfChange}
                accept=".pdf"
                currentFileName={attachedPdfName}
                idSuffix="die-pdf"
                dieId={formData.id}
                onFileRemove={onFileRemove}
                fileUrl={initialData?.die_Pdf}
              />
            </div>
          </div>
          <div className="">
            <div className="flex items-center gap-3 mb-6">
              <MdAttachFile size={18} className="text-primary" />
              <span className="text-[10px] font-black text-gray-400 uppercase tracking-[2.5px]">
                Die Image
              </span>
            </div>
            <div className="">
              <InputField
                type="image"
                label=""
                onChange={(file) => setImageFile(file)}
                previewUrl={imageFile}
                dieId={formData.id}
                onFileRemove={onFileRemove}
              />
            </div>
          </div>
        </div>

      </form>

      <FormFooter
        onCancel={onCancel}
        onSubmit={() => handleSave("close")}
        isSaving={isSaving}
        submitText={isEditing ? "Update" : "Save"}
      >
        {!isEditing && (
          <>
            <button
              type="button"
              onClick={() => handleSave("blank")}
              className="px-6 py-3 border border-gray-800 text-gray-800 font-black text-[10px] uppercase tracking-[2px] hover:bg-gray-900 hover:text-white transition-all disabled:opacity-50"
              disabled={isSaving}
            >
              Save & Add Blank
            </button>

            <button
              type="button"
              onClick={() => handleSave("sameInvoice")}
              className="px-6 py-3 border border-gray-800 text-gray-800 font-black text-[10px] uppercase tracking-[2px] hover:bg-gray-900 hover:text-white transition-all disabled:opacity-50"
              disabled={isSaving}
            >
              Save & Same Invoice
            </button>
          </>
        )}
      </FormFooter>

      <Model
        isOpen={!!modalType}
        onClose={() => setModalType(false)}
        name={`System Entry | ${modalType}`}
      >
        <EntityAddModal type={modalType} onClose={(newItem) => handleEntityAddSuccess(modalType, newItem)} />
      </Model>
    </div>
  );
};

export default DieForm;
